export default "__VITE_ASSET__DsgEW9vb__"